import { useMsal } from '@azure/msal-react'
import type { PropsWithChildren } from 'react'

import { useAvailableConfigurationPersonas } from '../hooks/useAvailableConfigurationPersonas'
import { NoRolesScreen } from './NoRolesScreen'

export const PersonaRolesGuard = ({ children }: PropsWithChildren) => {
  const { inProgress } = useMsal()
  const availablePersonas = useAvailableConfigurationPersonas()

  if (inProgress !== 'none') {
    return null
  }

  if (availablePersonas.length === 0) {
    return <NoRolesScreen />
  }

  return <>{children}</>
}
